import { render, staticRenderFns } from "./EventStatus.vue?vue&type=template&id=f498bcbe&scoped=true&"
import script from "./EventStatus.vue?vue&type=script&lang=js&"
export * from "./EventStatus.vue?vue&type=script&lang=js&"
import style0 from "./EventStatus.vue?vue&type=style&index=0&id=f498bcbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f498bcbe",
  null
  
)

export default component.exports